export default function CarouselSection() {
  const items = [
    {
      title: '国产科幻崛起之路',
      desc: '从《流浪地球》到《三体》，国产科幻影视正以前所未有的速度走向世界舞台中央',
      img: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20scene%20with%20dramatic%20space%20lighting%2C%20epic%20cosmic%20backdrop%2C%20Chinese%20science%20fiction%20aesthetic%2C%20warm%20orange%20and%20deep%20blue%20contrast%2C%20cinematic%20composition%2C%20no%20text%2C%20atmospheric%20mood&width=600&height=360&seq=carousel-01&orientation=landscape',
      tag: '专题策划',
    },
    {
      title: '金庸武侠影视回顾',
      desc: '重温那些年我们一起追过的金庸经典，《射雕》《天龙》《倚天》一个都不能少',
      img: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20ancient%20landscape%20with%20dramatic%20misty%20mountains%2C%20warm%20golden%20sunset%20lighting%2C%20wuxia%20cinematic%20aesthetic%2C%20heroic%20epic%20feel%2C%20no%20text%2C%20atmospheric%20composition&width=600&height=360&seq=carousel-02&orientation=landscape',
      tag: '经典回顾',
    },
    {
      title: '2026暑期档看什么',
      desc: '暑期档大片云集，科幻、喜剧、动画、动作全覆盖，这份观影指南请收好',
      img: 'https://readdy.ai/api/search-image?query=Summer%20cinema%20vibe%20with%20warm%20tropical%20sunset%20colors%2C%20movie%20theater%20atmosphere%2C%20entertainment%20and%20excitement%2C%20vibrant%20cinematic%20composition%2C%20dark%20background%20with%20warm%20accents%2C%20no%20text&width=600&height=360&seq=carousel-03&orientation=landscape',
      tag: '观影指南',
    },
    {
      title: '悬疑剧为什么越来越火',
      desc: '从《隐秘的角落》到《漫长的季节》，国产悬疑剧如何一步步征服观众的心',
      img: 'https://readdy.ai/api/search-image?query=Mysterious%20noir%20visual%20with%20dark%20alleyway%20and%20single%20warm%20streetlamp%2C%20suspenseful%20cinematic%20mood%2C%20atmospheric%20fog%2C%20thriller%20film%20aesthetic%2C%20no%20text%2C%20deep%20shadows&width=600&height=360&seq=carousel-04&orientation=landscape',
      tag: '深度分析',
    },
    {
      title: '日漫改编真人版盘点',
      desc: '哪些漫改真人版值得一看？从《浪客剑心》到《海贼王》，口碑与雷作一网打尽',
      img: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20and%20live-action%20crossover%20visual%2C%20dynamic%20art%20style%20blend%2C%20warm%20amber%20and%20cool%20blue%20contrast%2C%20cinematic%20composition%2C%20no%20text%2C%20dramatic%20lighting&width=600&height=360&seq=carousel-05&orientation=landscape',
      tag: '漫改盘点',
    },
  ];

  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-50 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
            焦点专题
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">精选深度内容，带你发现更多好片好剧</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.slice(0, 3).map((item, i) => (
            <div
              key={i}
              className="group bg-background-50 rounded-xl border border-background-200/50 overflow-hidden cursor-pointer transition-all duration-300 hover:border-accent-500/20"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 text-xs font-medium bg-accent-500/20 text-accent-400 rounded-md border border-accent-500/30 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-semibold text-foreground-100 mb-2">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}

          {items.slice(3, 5).map((item, i) => (
            <div
              key={i + 3}
              className="group bg-background-50 rounded-xl border border-background-200/50 overflow-hidden cursor-pointer transition-all duration-300 hover:border-accent-500/20 sm:col-span-2 lg:col-span-2"
            >
              <div className="flex flex-col sm:flex-row">
                <div className="relative h-48 sm:h-auto sm:w-1/2 overflow-hidden shrink-0">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t sm:bg-gradient-to-r from-background-50 via-transparent to-transparent"></div>
                  <div className="absolute top-3 left-3">
                    <span className="px-2.5 py-1 text-xs font-medium bg-accent-500/20 text-accent-400 rounded-md border border-accent-500/30 whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                </div>
                <div className="p-5 sm:p-6 flex flex-col justify-center">
                  <h3 className="text-base font-semibold text-foreground-100 mb-2">{item.title}</h3>
                  <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}